import gql from 'graphql-tag';
import { TranslationData } from '../../definitions/schemas';
import Interface from '../Interface';

interface GetTranslationsData {
  translations: TranslationData;
}

interface GetTranslationInput {
  language: string;
}

export default class TranslationInterface extends Interface {
  public async get(variables: GetTranslationInput) {
    const response = await this.query<GetTranslationsData>(
      () =>
        this.apolloService.executeQuery<GetTranslationsData>({
          query: gql`
            query translations($language: LanguageEnum!) {
              translations(language: $language)
            }
          `,
          variables,
        }),
      'Error getting language translation'
    );

    return response.translations;
  }
}
